import React, { useState, useEffect, useCallback } from "react";
import ClientInformation from "./ClientInformation";
import Billing from "./Billing";
import Inductions from "./Indunctions";
import { connect, useDispatch, useSelector } from "react-redux";
import ComplianceChecklist from "./ComplianceChecklist";
import Dialog from "../../../../../../common/element/Dialog";
import * as userActions from "../../../../../../actions/index";
import { useParams } from "react-router-dom";
import { setDefaultTab } from "../../../../../../redux/classes/Admin-Client/shiftTabSlice";
import ClientDetails from "../../Dialog/Clients/ClientSettings/ClientDetails";
import ValidationCriteria from "../../SpecificClientTabs/ValidationCriteria";
import SettingIcon from "../../../../../../assets/icons-svg/setting.svg";
import { setBreadcrumbs } from "../../../../../../redux/classes/breadcrumbsSlice";
import useUnauthorizedHandler from "../../../../../../common/snippet/useUnauthorizedHandler";
import { DashboardClientCompanyInductions } from "../../../../../../actions/Admin-Client/AllSiteApi";
import { GetClientProviderComplianceStatusCount } from "../../../../../../actions/Admin-Client/AllSiteApi";
import { decryptId } from "../../../../../../common/encryptDecrypt/encryptdecrypt";
import TotalClientsAndProviders from "../../DashboardAllClient/TotalClientsAndProviders";
const Overview = (props) => {
  const { id } = useParams();
  const orgId = decryptId(id);
  const dispatch = useDispatch();
  const handleUnauthorizedAccess = useUnauthorizedHandler()
  const activeTab = useSelector((state) => state.tabChange);
  const [dialogAddOpen, setAddOpen] = useState(false);
  const [userSetting, showUserSetting] = useState(false);
  const [clientFunctionId, setProviderfunctionId] = useState("")
  const AllFunctions = useSelector((state) => state.allFunctions);
  const [clientDataName, setClientDataName] = useState([])
  const [editBtnHide, setEditBtnHide] = useState(false)
  const [clientData, setClientData] = useState({
    compliant: 0,
    non_compliant: 0,

  });

  const loginData = JSON.parse(localStorage.getItem("LoginUserData"));
  let role_assignment_id;
  if (loginData) {
    role_assignment_id = loginData?.data?.role_assignment_id;
  }

  useEffect(() => {
    if (AllFunctions?.allFunction) {
      let functionType = AllFunctions?.allFunction.filter(
        (item) => item?.function_name === "client" // client function id 
      );
      setProviderfunctionId(functionType[0]?.function_id);
    }
  }, []);
  useEffect(() => {
    if (activeTab == "tab5Click") {
      setTimeout(() => {
        dispatch(setDefaultTab(""))
      }, 500);
    }
  }, [activeTab])
  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        { label: "View All Clients", url: "/admin/client/view-all-clients", home: "/admin/client/dashboard" },
        {
          label: props?.clientData?.trading_name,
          url: `/admin/client/view-all-clients/specific-client/${encodeURIComponent(id)}`,
        },
        {
          label: "Overview",
          url: `/admin/client/view-all-clients/specific-client/${encodeURIComponent(id)}`,
        },
      ])
    )
  }, [props?.clientData]);

  const openAddDialog = () => {
    setAddOpen(true);
  };
  const onAddDialogClose = (e) => {
    setAddOpen(false);
  };
  // Hide the user settings dialog
  const userSettingHide = () => {
    setTimeout(() => {
      // showUserSetting(false);
      setAddOpen(false);
    }, 0);
    setAddOpen(false);
  };

  const GetSpecificUserRole = useCallback(async () => {
    if (role_assignment_id) {
      dispatch(userActions.GetSpecificUserRole(role_assignment_id)).then(
        (response) => {
          if (response?.success === true) {
          } else if (response?.status === 401) {
            handleUnauthorizedAccess();
          }
        }
      );
    }
    // eslint-disable-next-line
  }, [dispatch]);
  useEffect(() => {
    GetSpecificUserRole();
  }, []);

  const fetchClientCompanyInductions = useCallback(async (function_assignment_id) => {
    try {
      const response = await dispatch(DashboardClientCompanyInductions(function_assignment_id));
      if (response.success) {
        const arrayData = response?.data;
        setClientDataName(arrayData);
        setEditBtnHide(true)
      } else if (response?.status === 401) {
        handleUnauthorizedAccess();
      } else {
        // Handle other errors
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }, [dispatch]);

  useEffect(() => {
    if (props?.clientData?.function_assignment_id) {
      fetchClientCompanyInductions(props?.clientData.function_assignment_id);
    }
  }, [props?.clientData?.function_assignment_id]);

  const fetchClientProviderComplianceStatusCount = useCallback(() => {
    if (orgId && clientFunctionId) {

      dispatch(GetClientProviderComplianceStatusCount({ client_org_id: orgId, function_id: clientFunctionId||"" }))
        .then((response) => {
          if (response.success) {
            setClientData({
              compliant: response?.data?.compliant || 0,
              non_compliant: response?.data?.non_compliant || 0,
              
            });
          } else if (response.status === 401) {
            handleUnauthorizedAccess();
          }
        })
        .catch((error) => {
          // Handle error here
          console.error("Error fetching client data: ", error);
        });
    }
  }, [dispatch,clientFunctionId,orgId]);

  useEffect(() => {
    fetchClientProviderComplianceStatusCount();
  }, [fetchClientProviderComplianceStatusCount,orgId,clientFunctionId]);

  return (
    <div className="grid grid-container gap-8">
      <div className="flex gap-8 flex-col">
        <ClientInformation
          clientData={props?.clientData}
          openAddDialog={openAddDialog}
          GetClientOverviewProfileById={props?.GetClientOverviewProfileById}
        />
        <Billing setDefaultTab={props?.setDefaultTab} />
      </div>

      <div className="flex gap-8 flex-col cstm-size">
        <TotalClientsAndProviders chartData={clientData} title={"Providers"} 
        redirectPath={"/admin/client/view-all-clients"} setDefaultTab={props?.setDefaultTab} />
        
        <ComplianceChecklist changeTabVal={props.changeTabVal} setDefaultTab={props?.setDefaultTab} />
        <Inductions clientDataName={clientDataName} clientData={props?.clientData} setDefaultTab={props?.setDefaultTab} editBtnHide={editBtnHide} />
      </div>

      <Dialog
        isOpen={dialogAddOpen}
        onClose={userSettingHide}
        onRequestClose={userSettingHide}
        bodyOpenClassName="overflow-hidden"
      >
        <div className="flex border-b  pb-5 px-6 pt-6 items-center">
          <span className="h-12 w-12 border rounded-lg border-gray-200 flex items-center justify-center shadow-sm mr-4">
            <img src={SettingIcon} alt="" />
          </span>
          <div>
            <h5 className="mb-1 text-gray-900 text-base font-semibold">
              Settings
            </h5>
          </div>
        </div>
        <div className="pt-2 px-6">
          <ClientDetails GetClientOverviewProfileById={props?.GetClientOverviewProfileById} userSettingHide={userSettingHide} />
        </div>
      </Dialog>
      {/* <Dialog
        isOpen={dialogAddOpen}
        onClose={userSettingHide}
        onRequestClose={userSettingHide}
        bodyOpenClassName="overflow-hidden"
      >
        <div className="flex border-b  pb-5 px-6 pt-6 items-center">
          <span className="h-12 w-12 border rounded-lg border-gray-200 flex items-center justify-center shadow-sm mr-4">
            <img src={SettingIcon} alt="" />
          </span>
          <div>
            <h5 className="mb-1 text-gray-900 text-base font-semibold">
              Settings
            </h5>
          </div>
        </div>
        <div className="pt-2 px-6">
          <ValidationCriteria userSettingHide={userSettingHide} />
        </div>
      </Dialog> */}
    </div>
  );
};
export default Overview;
